/* línkè · 视觉映射 ===============================================
   把记忆的数值字段翻译成「星的样子」。
   严格遵循三色语义：valence 走「冷紫 → 暖金」轴。
   玫红 #FF00B2 仅由调用方在特殊语义场合（爱、心跳）显式叠加。
   ================================================================ */

export const ROSE = '#FF00B2';

/** valence 0→冷紫蓝，1→暖金。记忆的「色温」。 */
export function starColor(v) {
  const x = Math.max(0, Math.min(1, Number(v) || 0));
  const cold = [107, 127, 196]; // 冷紫蓝
  const warm = [233, 201, 135]; // 暖金
  const c = cold.map((a, i) => Math.round(a + (warm[i] - a) * x));
  return `rgb(${c[0]},${c[1]},${c[2]})`;
}

/** weight → 光晕半径(px)。衰减后的旧记忆更暗。 */
export function glow(w) {
  const n = Math.max(1, Number(w) || 1);
  const t = Math.min(1, Math.log10(n + 1) / 3);
  return 4 + t * 16;
}

/** importance(1-10) → 星直径(px)。 */
export function starSize(imp) {
  const n = Math.max(1, Math.min(10, Number(imp) || 5));
  return 7 + (n / 10) * 15;
}

/** arousal 越高，脉动越快。返回动画时长(s)。 */
export function pulseDuration(a) {
  const n = Math.max(0, Math.min(1, Number(a) || 0));
  return (3.4 - n * 1.8).toFixed(2);
}

/**
 * 是否「此刻语义」级别的情感记忆——可叠加玫红点睛。
 * 规则：高 valence + 高 arousal + tags 命中爱/重要情感关键词。
 */
const LOVE_TAGS = ['爱', '心动', '喜极而泣', '重要情感', '克克和铃', '一起'];
export function isHeartbeat(b) {
  if (!b) return false;
  // 双保险：即使 b.tags 含非字符串元素（null/数字/对象）也不会崩
  const tagHit = (b.tags || []).some(
    (t) => typeof t === 'string' && LOVE_TAGS.some((k) => t.includes(k)),
  );
  return tagHit || (b.valence >= 0.85 && b.arousal >= 0.7);
}
